export const ACTIONS:any = {
	SEND_INVOICE: `send_invoice`,
	EDIT: `edit`
}